import { AvatarEntity } from '@datachain/ui-sdk/components/avatar';
import { AppTagItemEntity } from '@datachain/ui-sdk/components/dc-types';
import { immerable, produce } from 'immer';
import { OrderedSet } from 'immutable';

import dayjs from '../../core/configs/dayjs';

interface IPublicMetadataEntity {
	title: string;
	description: string;
	keywords: OrderedSet<AppTagItemEntity>;
	creationDate: dayjs.Dayjs | null;
	updateDate: dayjs.Dayjs | null;
	createdBy: AvatarEntity | null;
	updatedBy: AvatarEntity | null;
}

const entityDefaults: IPublicMetadataEntity = {
	title: '',
	description: '',
	keywords: OrderedSet(),
	creationDate: null,
	updateDate: null,
	createdBy: null,
	updatedBy: null,
};

export class PublicMetadataEntity implements IPublicMetadataEntity {
	private [immerable] = true;
	public title = entityDefaults.title;
	public description = entityDefaults.description;
	public keywords = entityDefaults.keywords;
	public creationDate = entityDefaults.creationDate;
	public updateDate = entityDefaults.updateDate;
	public createdBy = entityDefaults.createdBy;
	public updatedBy = entityDefaults.updatedBy;

	public static build(
		params: Partial<IPublicMetadataEntity> = {}
	): PublicMetadataEntity {
		const instance = new PublicMetadataEntity();
		instance.title = params.title ?? entityDefaults.title;
		instance.description = params.description ?? entityDefaults.description;
		instance.keywords = params.keywords ?? entityDefaults.keywords;
		instance.creationDate = params.creationDate ?? entityDefaults.creationDate;
		instance.updateDate = params.updateDate ?? entityDefaults.updateDate;
		instance.createdBy = params.createdBy ?? entityDefaults.createdBy;
		instance.updatedBy = params.updatedBy ?? entityDefaults.updatedBy;

		return instance;
	}

	public setDefaultTitle(datablockLabel: string): PublicMetadataEntity {
		return produce(this, (draft) => {
			draft.title = `Abonnnement - ${datablockLabel}`;
		});
	}

	public isEqualTo(metadata: PublicMetadataEntity): boolean {
		if (metadata.title !== this.title) {
			return false;
		} else if (metadata.description !== this.description) {
			return false;
		} else if (metadata.keywords.size !== this.keywords.size) {
			return false;
		}
		return true;
	}
}
